/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */
import GameShell from './components/GameShell';

function App() {
  return <GameShell />;
}

export default App;